import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import LocationsApi from '../generated/api/Locations';

export default (service: Servicelayer) => ({
  ...LocationsApi(service),

  // Add custom calls here

});
